export default {
  parentInventory: (state) => state,
  circleValue: (state) => state.results.dashboard.circleValue,
  counters: (state) =>
    state.results.dashboard ? state.results.dashboard.counters : [],
  pagination: (state) => state.results.pagination,
  results: (state) => state.results.items || [],
  academicYearName: (state) =>
    state.selectedAcademicYear ? state.selectedAcademicYear.description : null,
  selectedAcademicYearId: (state) =>
    state.selectedAcademicYear ? state.selectedAcademicYear.id : null,
};
